module.exports = __webpack_public_path__ + "img/pic3.99464229.jpg";